(function () {
  const targetHandle = 'custom-willow-wheat-w07-1-top-down-bottom-up-bamboo-shades';
  const root = document.querySelector(`.fd-pdp[data-product-handle="${targetHandle}"]`);
  if (!root) return;

  const normalize = (value) => String(value || '')
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim();

  const getWrapperTitle = (wrapper) => {
    const title = wrapper.querySelector('.bcpo-title, .bcpo-label, .bcpo-label label');
    if (title) return title.textContent;

    const firstDirectLabel = Array.from(wrapper.children || []).find((child) => child.tagName === 'LABEL');
    return firstDirectLabel ? firstDirectLabel.textContent : (wrapper.getAttribute('data-title') || '');
  };

  const isFullWidthOption = (title, wrapper) => {
    if (wrapper.classList.contains('fd-bcpo-color-option')) return true;
    return /(^| )(color|colour|fabric)( |$)|install(ation)? type|warranty|room label|measurement guide|customize/.test(title);
  };

  const decorateBcpoLayout = () => {
    const bcpo = root.querySelector('#bcpo');
    if (!bcpo) return;

    const wrappers = Array.from(bcpo.querySelectorAll('.selector-wrapper'))
      .filter((wrapper) => !wrapper.parentElement.closest('.selector-wrapper'));
    if (!wrappers.length) return;

    const layoutParents = new Set();
    wrappers.forEach((wrapper) => {
      const title = normalize(getWrapperTitle(wrapper));
      wrapper.classList.add('fd-bcpo-layout-item');
      wrapper.classList.toggle('fd-bcpo-layout-span-2', isFullWidthOption(title, wrapper));
      wrapper.dataset.fdWillowOption = title.replace(/\s+/g, '-');
      if (wrapper.parentElement) layoutParents.add(wrapper.parentElement);
    });

    layoutParents.forEach((parent) => parent.classList.add('fd-bcpo-layout-grid'));
    if (wrappers.every((wrapper) => wrapper.parentElement === bcpo)) {
      bcpo.classList.add('fd-bcpo-layout-grid');
    }
  };

  const decorateGuideLinks = () => {
    const guideLabels = {
      'bamboo-depth': 'Window depth & headrail guide',
      'bamboo-measurement': 'Measurement finder & guide',
      'bamboo-lining': 'Liner & shading guide'
    };

    Object.entries(guideLabels).forEach(([key, label]) => {
      const link = root.querySelector(`.fd-pdp-inline-guide-link[data-fd-inline-guide="${key}"]`);
      if (!link) return;
      if (link.textContent.trim() !== label) link.textContent = label;
      link.classList.add('fd-willow-guide-link');
    });
  };

  let frame = 0;
  const scheduleDecorate = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      decorateBcpoLayout();
      decorateGuideLinks();
    });
  };

  scheduleDecorate();
  [300, 900, 1800, 3200].forEach((delay) => window.setTimeout(scheduleDecorate, delay));

  if (window.MutationObserver) {
    const observer = new MutationObserver(scheduleDecorate);
    observer.observe(root, { childList: true, subtree: true });
  }

  const recentlyViewed = document.querySelector(
    `[data-section-type="recently-viewed"][data-product-handle="${targetHandle}"]`
  );
  const priceCache = new Map();

  const formatPrice = (product) => {
    const amount = product && Number(product.price_min);
    if (!Number.isFinite(amount)) return '';
    if (window.theme && theme.Currency && typeof theme.Currency.formatMoney === 'function') {
      const prefix = theme.strings && theme.strings.productFrom ? theme.strings.productFrom : '';
      return `${prefix}${theme.Currency.formatMoney(amount, theme.moneyFormat)}`;
    }
    return `$${(amount / 100).toFixed(2)}`;
  };

  const loadProductPrice = (url) => {
    const pathname = new URL(url, window.location.origin).pathname.replace(/\/$/, '');
    if (!priceCache.has(pathname)) {
      priceCache.set(
        pathname,
        window.fetch(`${pathname}.js`, { credentials: 'same-origin' })
          .then((response) => {
            if (!response.ok) throw new Error(`Product price request failed: ${response.status}`);
            return response.json();
          })
          .then(formatPrice)
          .catch(() => '')
      );
    }
    return priceCache.get(pathname);
  };

  const decorateRecentlyViewedPrices = () => {
    if (!recentlyViewed) return;
    recentlyViewed.querySelectorAll('.grid-product__link').forEach((link) => {
      const meta = link.querySelector('.grid-product__meta');
      if (!meta || meta.querySelector('.grid-product__price') || link.dataset.fdPricePending === 'true') return;

      link.dataset.fdPricePending = 'true';
      loadProductPrice(link.href).then((price) => {
        if (!price || !link.isConnected || meta.querySelector('.grid-product__price')) return;
        const priceElement = document.createElement('div');
        priceElement.className = 'grid-product__price';
        priceElement.textContent = price;
        meta.appendChild(priceElement);
      }).finally(() => {
        delete link.dataset.fdPricePending;
      });
    });
  };

  decorateRecentlyViewedPrices();
  if (recentlyViewed && window.MutationObserver) {
    const recentlyViewedObserver = new MutationObserver(decorateRecentlyViewedPrices);
    recentlyViewedObserver.observe(recentlyViewed, { childList: true, subtree: true });
  }
})();
